import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getSales } from "../../../redux/slice/sale-slice";
import ProductsTable from "./components/products-table";
import SearchComponent from "./components/search-component";


const SalesAllPage = () =>{

    const diaptch = useDispatch();

    useEffect(()=>{
        diaptch(getSales())
    },[])

    return(
        <>
        <SearchComponent/>
        <ProductsTable/>
        </>
    )
}

export default SalesAllPage;